<template>
  <!-- 知识库页面 -->
  <div class="knowledgeView-controller">
    <el-container>
      <!-- 返回按钮 -->
      <el-header class="header-container">
        <div class="back-button-container">
          <el-button
              class="back-btn"
              icon="el-icon-arrow-left"
              @click="goBack"
              circle
              type="primary"
          ></el-button>
        </div>
      </el-header>

      <el-container>
        <!-- 知识库解答主体HTML模块 -->
        <el-main>
          <iframe :src="htmlContent" frameborder="0" :style="{ width: '100%', height: '100%' }"></iframe>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "KnowledgeView",
  data() {
    return {
      htmlContent: ''
    };
  },
  methods: {
    goBack() {
      this.$router.back(); // 路由返回上一页
    }
  },
  mounted() {
    try {
      const htmlUrl = this.$route.query.postUrl + this.$route.query.id;
      this.htmlContent = `http://10.1.65.11:9000${htmlUrl}.html`;
    } catch (error) {
      console.error('Failed to load HTML content:', error);
      // 可以在这里添加更多的错误处理逻辑，比如显示错误提示
    }
  },
  beforeDestroy() {
    // 可以在这里添加一些清理工作
  }
};
</script>

<style scoped>
.header-container {
  padding: 0 !important;
  height: 40px !important;
}

.back-button-container {
  padding: 5px 0 0 5px;
}

.back-btn {
  font-size: 18px;
  width: 32px;
  height: 32px;
  padding: 0 !important;
}

::v-deep .el-aside {
  border: 1px solid WhiteSmoke;
  /* 隐藏滚动条 */
  overflow: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

::v-deep .el-header {
  padding: 0 10px;
  line-height: normal;
  background-color: #ffffff;
}

::v-deep .el-main {
  padding: 5px;
}

.knowledgeView-controller {
  width: 100%;
  height: 100%;
  display: flex;
}
</style>
